export default __webpack_public_path__ + "static/media/cisius_2.0cc07146.png";